export const loadFeed = async (url) => {
    return fetch(url)
        .then((response) => response.json())
        .catch((error) => {});
};
